import { render, staticRenderFns } from "./GrainSpecifications.vue?vue&type=template&id=092e887a&scoped=true"
import script from "./GrainSpecifications.vue?vue&type=script&lang=js"
export * from "./GrainSpecifications.vue?vue&type=script&lang=js"
import style0 from "./GrainSpecifications.vue?vue&type=style&index=0&id=092e887a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092e887a",
  null
  
)

export default component.exports